// import {isEmpty} from 'lodash';
import { serviceMaker, methods, api } from "./index.js";

export const getBulkUploads = () =>
  serviceMaker(`/datauploads?limit=14&offset=0`, methods.GET, api.NGB);
export const addBulkUploads = (data) =>
  serviceMaker("/datauploads/documents", methods.POST, api.NGB, data);
export const processFile = (id) =>
  serviceMaker(`/datauploads/${id}`, methods.PUT, api.NGB);
export const getSchedulerJobs = () =>
  serviceMaker(`/jobs`, methods.GET, api.NGB);
export const getMessageLog = () =>
  serviceMaker(`/messages/messageData`, methods.GET, api.NGB);

export const getMessageLogSearch = (messageType, status) => {
  let query = [];
  if (messageType) query.push(`messageType=${messageType}`);
  if (status) query.push(`status=${status}`);

  const url = `/messages/messageData${query.length ? "?" + query.join("&") : ""}`;
  return serviceMaker(url, methods.GET, api.NGB);
};
// export const getMessageLog = () =>
//   serviceMaker(`/messages/messageData?messageType=M&status=N`, methods.GET, api.NGB);
export const viewSchedulerJobs = (id) =>
  serviceMaker(`/jobs/${id}`, methods.GET, api.NGB);
export const jobParameters = (id) =>
  serviceMaker(`/jobs/${id}/jobparameters`, methods.GET, api.NGB);
export const executeJobs = (id) =>
  serviceMaker(`/jobs/${id}?command=executeJob`, methods.POST, api.NGB);
export const updateJob = (id, data) =>
  serviceMaker(`/jobs/${id}`, methods.PUT, api.NGB, data);
export const updateJobParameters = (id, data) =>
  serviceMaker(`/jobs/${id}/jobparameters`, methods.PUT, api.NGB, data);
export const getSchedulerStatus = () =>
  serviceMaker(`/scheduler`, methods.GET, api.NGB);
export const setSchedulerStatus = (data) =>
  serviceMaker(`/scheduler?command=${data}`, methods.POST, api.NGB, {});
export const getSchedulerHistpry = (id) =>
  serviceMaker(`/jobs/${id}/runhistory`, methods.GET, api.NGB);
export const downloadLogFile = (id) =>
  serviceMaker(
    `/jobs/printlog/${id}?tenantIdentifier=default`,
    methods.GET,
    api.NGB
  );
//  export const editSchedulerJobs = (id) => serviceMaker(`/jobs/${id}`, methods.GET, api.NGB);

export const onlinePayment = () =>
  serviceMaker(`/paymentgateways?limit=14&offset=0`, methods.GET, api.NGB);
export const paymentListByType = (payload) => {
  let url = `/paymentgateways`;
  let paramsUrl = "";
  if (Object.keys(payload).length) {
    url = url + "?";
    Object.keys(payload).forEach((el, ind) => {
      if (ind > 0) {
        paramsUrl += "&";
      }
      paramsUrl += `${el}=${payload[el]}`;
    });
    url = url + paramsUrl;
  }
  return serviceMaker(url, methods.GET, api.NGB);
};
export const editPaymentList = (payload) =>
  serviceMaker(`/paymentgateways/${payload.id}`, methods.GET, api.NGB);
export const saveEditPayment = (id, data) =>
  serviceMaker(`/paymentgateways/${id}`, methods.PUT, api.NGB, data);
export const onlinePaymentsSearch = (payload) => {
  if (payload.gateway && payload.payStatus) {
    return serviceMaker(
      `/paymentgateways?limit=14&offset=0&source=${payload.gateway}&tabType=${payload.payStatus}`,
      methods.GET,
      api.NGB
    );
  } else if (payload.gateway && !payload.payStatus) {
    return serviceMaker(
      `/paymentgateways?limit=14&offset=0&source=${payload.gateway}`,
      methods.GET,
      api.NGB
    );
  } else if (!payload.gateway && payload.payStatus) {
    return serviceMaker(
      `/paymentgateways?limit=14&offset=0&&source=All&tabType=${payload.payStatus}`,
      methods.GET,
      api.NGB
    );
  }
};
export const downloadData = ({ baseURL, searchItems, searchSecondItems }) => {
  try {
    window.open(
      baseURL +
        `/paymentgateways/download?fromDate=1709231400000&source=${searchItems}&status=${searchSecondItems}&toDate=1709551472954&tenantIdentifier=default`
    );
    return true;
  } catch (error) {
    throw Error("Something went wrong");
  }
};
export const getMakerCheckerlList = () =>
  serviceMaker(`/permissions?makerCheckerable=true`, methods.GET, api.NGB);
export const viewApprovals = (id) =>
  serviceMaker(`/audits/${id}`, methods.GET, api.NGB);
export const editMakerChecker = (payload) =>
  serviceMaker(
    `/permissions/${payload.code}`,
    methods.PUT,
    api.NGB,
    payload.isEnabled
  );
export const getApprovalList = () =>
  serviceMaker(`/makercheckers`, methods.GET, api.NGB);
export const getPermission = (payload) =>
  serviceMaker(
    `/makercheckers/${payload.id}?command=${payload.permission}`,
    methods.POST,
    api.NGB
  );

  export const getConductorWorkflowStatus = (date) =>
  serviceMaker(`/runreports/Daily%20wise%20conductor%20status%20?R_startDate=${date.startDate}&R_endDate=${date.endDate}`, methods.GET, api.NGB);
  
  export const getStatusWiseChart = (date) =>
  serviceMaker(`/runreports/Daily%20conductor%20workflow%20status%20wise?R_startDate=${date.startDate}&R_endDate=${date.endDate}`, methods.GET, api.NGB);
export const getOrderDateFilter = (date) =>
  serviceMaker(`/provisioning/provisioningactions?startDate=${date.startDate}&endDate=${date.endDate}`, methods.GET, api.NGB);

export const getMessageDateFilter = (data) => {
  const query = [];

  if (data.startDate) query.push(`startDate=${data.startDate}`);
  if (data.endDate) query.push(`endDate=${data.endDate}`);
  if (data.messageType) query.push(`messageType=${data.messageType}`);
  if (data.status) query.push(`status=${data.status}`);

  const url = `/messages/messageData${query.length ? "?" + query.join("&") : ""}`;

  return serviceMaker(url, methods.GET, api.NGB);
};